<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">درخواست تحویل فیزیکی طلا</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12 style="padding:20px;">
            <v-card>
                <v-card-title>
                    <v-layout wrap row>
                       
                        <v-flex xs12 sm12 lg6 md6 xl6 style="padding:30px">
                            <v-layout row wrap>
                               
                                <v-flex xs12 sm12 md12 lg12 xl12 >
                                    <v-row>
                                        
                                        <v-col cols="12" >
                                            <JsonExcel :data="dtData" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExcelFields">
                                                <v-btn dark color="baseColor">
                                                    <v-icon small style="padding-left:5px;">fas fa-file-excel</v-icon>&nbsp;
                                                    خروجی اکسل
                                                </v-btn>
                                            </JsonExcel>
                                        </v-col>
                                    </v-row>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text>
                    <v-data-table :items="dtData" :headers="dtHeaders">
                        <template v-slot:[`item.g_Status`]="{ item }">
                            <v-chip small color="orange" dark v-if="item.g_Status == 0">در حال بررسی</v-chip>
                            <v-chip small color="green" dark v-if="item.g_Status == 1"> تایید شد</v-chip>
                            <v-chip small color="red" dark v-if="item.g_Status == 2">  رد شد</v-chip>
                        </template>
                        <template v-slot:[`item.operation`]="{ item }">
                            <v-btn v-if="item.g_Status < 1" small outlined color="orange accent-2" @click="()=>{ChangeStateDialog = true;ItemId = item.g_Id}">تغییر</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
        </v-layout>
        <template>
            <v-dialog max-width="500px" v-model="ChangeStateDialog" persistent>
                <v-card>
                    <v-card-title>تغییر وضعیت درخواست</v-card-title>
                    <v-card-text>
                        <v-row wrap>
                            <v-col cols="12">
                                <v-row>
                                    <v-col cols="8">{{State? "تایید درخواست":"رد درخواست"}} :</v-col>
                                    <v-col
                                    cols="4"
                                    style="display: flex; justify-content: flex-end"
                                    >
                                    <v-switch
                                        v-model="State"
                                        style="
                                        padding-top: 0px !important;
                                        margin-top: 0px !important;
                                        "
                                        color="#2a2d45"
                                    ></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" v-if="!State">
                                <v-text-field outlined dense label="دلیل رد درخواست" v-model="declineresone"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn :loading="InProgress" @click="SaveChanges()" small outlined color="green accent-2">تغییر</v-btn>
                        <v-btn @click="()=>{ChangeStateDialog = false;declineresone = null;State=false}" small outlined color="gray accent-2">بستن</v-btn>
                    </v-card-actions>
                </v-card>

            </v-dialog>
        </template>
    </div>
    
</template>

<script>
const ApiUrl = require("../../constant/apiurl");
const MSGHNDL = require("../../constant/MessageHandler");

const axios = require('axios');
import JsonExcel from 'vue-json-excel'
import { async } from 'q';
export default {
    components:{
        JsonExcel
    },
    name:"goldtransactions",
    data:()=>({
        sStatus:-1,
        dtHeaders:[
            {text:"کاربر درخواست دهنده",value:"user.surename",sortable:true,align:"right"},
            {text:"مقدار (گرم)",value:"g_Weight",sortable:true,align:"right"},
            {text:"تاریخ درخواست ",value:"date",sortable:true,align:"right"},
            {text:"وضعیت ",value:"g_Status",sortable:true,align:"right"},
            {text:"دلیل رد درخواست ",value:"g_Reason",sortable:true,align:"right"},
            {text:"عملیات ",value:"operation",sortable:true,align:"right"},
        ],
       
        dtData:[],
        prodItems:[],
        Repository:[],
        ExcelFields:{
            ' کاربر درخواست دهنده':'user.surename',
            'مقدار (گرم)  ':'g_Weight',
            'تاریخ درخواست':'date',
            'دلیل رد درخواست':'g_Reason',
            'وضعیت':'status'
        },
        ChangeStateDialog:false,
        State:false,
        declineresone:null,
        ItemId:0,
        InProgress:false
       
    }),
    created(){
        this.LoadGoldDelivery();
    },
    methods:{
        async SaveChanges()
        {
            var vm = this;
            var Model = {};
            Model.G_Id = this.ItemId;
            Model.G_Status = this.State ? 1 : 2;
            Model.G_Reason = this.declineresone;
            this.InProgress = true;
            await axios.post(ApiUrl.GoldDeliveryChangeState,Model)
                .then(function (res) {
                    vm.InProgress = false;
                    if(res.data.status)
                    {
                       vm.LoadGoldDelivery();
                       vm.ChangeStateDialog = false;
                       vm.declineresone = null;
                       vm.State=false;
                       MSGHNDL.OK(res.data.msg);
                    }
                    else
                    {
                        MSGHNDL.ERR(res.data.msg);
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        },
        async LoadGoldDelivery()
        {
            let vm = this;
            var url=ApiUrl.GetGoldDelivery;
            
            await axios.post(url)
                .then(function (res) {
                    console.log(res);
                    vm.inUploading = false;
                    if(res.data.status)
                    {
                       vm.dtData = res.data.data;
                       vm.Repository = res.data.data;
                    }
                })
                .catch(function (error) {
                
                console.log(error);
                });
        }
    }
}
</script>